import styled from 'styled-components';
import { Spacing40, Spacing16, Spacing8, Spacing4 } from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';
import Flex from 'components/Layout/components/Flex';
import { Typography } from 'components/generic/typography';
import { useTranslation } from 'react-i18next';
import { AdditionalText } from 'autogen/translation-keys/trans-website-footer-featured';
import FeaturedFooter from '../../index';
import type { IFeaturedFooterModel, IFeaturedFooterTheme } from '../../shared/types';
import logo from './webapotek-logo.png';

const StyledMedicalCross = styled.img.attrs(({ theme }) => ({ src: theme.AssetsFeaturedFooterMedicalPictogram }))`
    && {
        width: 40px;
        height: 40px;
        margin-bottom: ${Spacing16};

        ${breakpoint.up(sizes.xl)} {
            margin-bottom: ${Spacing40};
            width: 65px;
            height: 65px;
        }
    }
`;

const Logo = styled.img`
    width: 189px;
    height: auto;
`;

const StyledFlex = styled(Flex)`
    padding: ${Spacing16};
    background-color: var(--color-health-4);
    text-align: center;
`;

export default function MedicalTheme({ model }: IFeaturedFooterModel): JSX.Element {
    const theme: IFeaturedFooterTheme = {
        Icon: StyledMedicalCross,
        background: 'var(--color-health-3)',
        buttonVariant: 'negative'
    };

    const { t } = useTranslation();

    return (
        <Flex.Column gap="0">
            <FeaturedFooter model={model} customTheme={theme} />
            <StyledFlex
                direction={{ xs: 'column', md: 'row' }}
                justifyContent="center"
                alignItems="center"
                gap={{ xs: Spacing8, md: Spacing4 }}
            >
                <Typography.Body as="span" size="M" strong>
                    {t(AdditionalText)}
                </Typography.Body>
                <Logo src={logo} alt="webapotek" />
            </StyledFlex>
        </Flex.Column>
    );
}
